<template>
    <Label class="flex items-center font-medium text-sm text-gray-700 cursor-pointer pb-2">
        <input
            class="rounded border-gray-300 text-primary shadow-sm focus:border-primary focus:ring focus:ring-primary focus:ring-opacity-50"
            type="checkbox"
            :name="name"
            :value="value"
            v-model="proxyChecked"
        >
        <span class="ml-2 text-sm text-gray-600">{{ label }}</span>
    </Label>
</template>

<script>
export default {
    emits: ['update:checked'],

    props: {
        name: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        checked: {
            type: [Array, Boolean],
            default: false,
        },
        value: {
            default: null,
        },
    },

    computed: {
        proxyChecked: {
            get() {
                return this.checked;
            },

            set(val) {
                this.$emit("update:checked", val);
            },
        },
    },
}
</script>
